/* cvn-nav-feedback.js — lifted verbatim out of sections/cvn-nav-feedback.liquid on 2026-09-25 (theme audit v77).
   It used to be an inline <script> re-sent with every page; as an asset it is minified by the CDN and cached.
   Execution point is unchanged: the snippet loads it (blocking, no defer) exactly where the block was. */
(function(){
  var main=document.getElementById('MainContent');
  var bar=document.getElementById('cvn-navbar');
  if(!main||!bar) return;
  var navigating=false;
  var keepEl=null; // the floating nav mark kept across the content swap (graceful exit v2)

  var loadedSrc={};
  (function(){ var ss=document.querySelectorAll('script[src]'); for(var i=0;i<ss.length;i++){ var s=ss[i].getAttribute('src'); if(s) loadedSrc[s]=1; } })();

  function layoutPref(){ var m=document.cookie.match(/(?:^|;\s*)cvn_layout=([^;]+)/); return (m && (m[1]==='grid'||m[1]==='showcase'))?m[1]:null; }

  /* Removes a modal the OUTGOING page left behind at <body> level. It is only ever correct to
     call this while #MainContent still holds the page those modals belong to — see the ordering
     note in swap(). */
  function cleanupOrphans(){
    try{
      var els=document.querySelectorAll('product-modal, .product-media-modal, .media-modal');
      for(var i=0;i<els.length;i++){ if(!els[i].closest('#MainContent')){ els[i].parentNode && els[i].parentNode.removeChild(els[i]); } }
    }catch(e){}
  }
  function clearBreadcrumbs(){ try{ var bc=document.querySelector('.cvn-bc-section'); if(bc) bc.innerHTML=''; }catch(e){} }

  function barStart(){ bar.style.transition='none'; bar.style.transform='scaleX(0.08)'; bar.style.opacity='1'; bar.getBoundingClientRect(); bar.style.transition='transform 8s cubic-bezier(0,.7,.25,1), opacity .18s ease'; bar.style.transform='scaleX(0.92)'; }
  function barDone(){ bar.style.transition='transform .28s ease, opacity .35s ease .12s'; bar.style.transform='scaleX(1)'; bar.style.opacity='0'; setTimeout(function(){ bar.style.transition='none'; bar.style.transform='scaleX(0)'; }, 420); }

  /* THE LOOP IS EARNED (Zeus, Option B — exact pages): on soft-nav only home and the
     TOP TWO LEVELS of the canvono-main menu get the brand loop: Shop's type pages,
     See All Collections + the GROUP pages, See All Vibes + Moods/Styles/Subjects, and
     Best Sellers. Individual niche and vibe pages live at the menu's THIRD level, so
     they keep the quiet track (a flat DOM scan of the mega menu wrongly admitted them
     — depth matters, so the list is emitted server-side by the nav section's Liquid,
     where levels are explicit: window.cvnMarkPaths). Query params are ignored (grid
     and gallery both match). Hard loads follow their own rule (snippets/cvn-boot.liquid):
     the full-screen boot overlay runs on every page EXCEPT product pages, where ad clicks
     land. Empty/missing list degrades to home-only. */
  var markSet=null;
  function wantsMark(u){
    try{
      var p=u.pathname.replace(/\/+$/,'').toLowerCase();
      if(p===''||p==='/') return true; // home
      if(!markSet){
        markSet={};
        var arr=window.cvnMarkPaths||[];
        for(var i=0;i<arr.length;i++){
          try{
            var q=new URL(arr[i], location.origin).pathname.replace(/\/+$/,'').toLowerCase();
            if(q.indexOf('/collections/')===0) markSet[q]=1;
          }catch(e){}
        }
      }
      return !!markSet[p];
    }catch(e){ return false; }
  }

  var TRACK='<div id="cvn-pageload"><div class="cvn-pl-inner"><div class="cvn-pl-track"></div></div></div>';
  /* THE BRANDED WAIT — when cvn-boot.liquid is on the page (every hard load renders it),
     the soft-nav void carries the same CANVONO assembly loop, centered where the content
     will land; header and footer stay live. window.cvnBootMark builds the mark (one machine,
     both surfaces — see snippets/cvn-boot.liquid). Falls back to the quiet track wherever
     the mark machine is absent (theme editor) or a build fails. */
  /* Camera ratio for the loader (the word era pushes IN from the logo-sized box). It is
     written INTO the markup, so the camera's animation is born with its final keyframes.
     ⚠ Never set --cvnb-zw once the loader is in the DOM: a composited animation whose
     var() keyframes change after it exists can keep stale keyframes on the compositor —
     measured on a loader OPENING on the wordmark: written after the build, every letter
     painted at 1/zw size, torn off its slot; written before the build, CANVONO stayed
     unzoomed. The logo opening happened to survive the late write, which is why it went
     unseen. BOX mirrors
     .cvnb-markbox's clamp(170px,34vw,280px) in sections/cvn-nav-feedback.liquid — change
     both together. */
  function camZw(){
    var box=Math.min(Math.max(170, 0.34*window.innerWidth), 280);
    return Math.max(1, Math.min(1.18*window.innerWidth, 0.62*window.innerHeight)/box).toFixed(4);
  }
  /* The OPENING (one of four — cvn-boot's draw, window.cvnBootOpening) rides in the markup
     too: the assembly loop's CANVONO wordmark as the class .cvnb-w (like the camera ratio, it
     must exist before the loader's tracks do; never apply it to a running loader from
     script — WebKit's composited camera and spin would ignore it while the letters obey
     it), or THE SNOWBALL as .cvnb-snow + data-cvnb-open ('snow-word' | 'snow-logo'): its own
     canvas over the whole loader, whose tracks window.cvnBootSnow creates right after the
     markup lands, with the opening as their delay (see snippets/cvn-boot.liquid). */
  function loaderHTML(markOk){
    if(markOk && window.cvnBootMark){
      var op=(window.cvnBootOpening && window.cvnBootOpening())||'logo';
      if(op.indexOf('snow')===0 && window.cvnBootSnow){
        return '<div id="cvn-pageload" class="cvnb-navload cvnb-snow" data-cvnb-open="'+op+'"><div class="cvnb-snowbox"><svg class="cvnb-snowsvg" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"></svg></div></div>';
      }
      var w=(op==='word')?' cvnb-w':'';
      return '<div id="cvn-pageload" class="cvnb-navload cvnb-run'+w+'" style="--cvnb-zw:'+camZw()+'"><div class="cvnb-markbox"><svg class="cvnb-svg" viewBox="0 105 1000 790" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"></svg></div></div>';
    }
    return TRACK;
  }

  function runScripts(container){
    var scripts=container.querySelectorAll('script');
    for(var i=0;i<scripts.length;i++){
      var old=scripts[i]; var src=old.getAttribute('src');
      if(src){
        if(loadedSrc[src]){ if(old.parentNode) old.parentNode.removeChild(old); continue; }
        loadedSrc[src]=1;
      }
      var n=document.createElement('script');
      for(var j=0;j<old.attributes.length;j++){ n.setAttribute(old.attributes[j].name, old.attributes[j].value); }
      n.textContent=old.textContent;
      if(old.parentNode) old.parentNode.replaceChild(n, old); else container.appendChild(n);
    }
  }

  function syncToggle(doc){
    try{
      var nvt=doc.querySelector('.cvn-vt'), lvt=document.querySelector('.cvn-vt');
      if(!nvt||!lvt) return;
      var nl=nvt.querySelectorAll('.cvn-vt-btn'), ll=lvt.querySelectorAll('.cvn-vt-btn');
      for(var k=0;k<ll.length && k<nl.length;k++){ ll[k].setAttribute('href', nl[k].getAttribute('href')); }
      lvt.setAttribute('data-oncol', nvt.getAttribute('data-oncol')||'0');
      var pref=layoutPref() || nvt.getAttribute('data-current') || 'showcase';
      lvt.setAttribute('data-current', pref);
      for(var i=0;i<ll.length;i++){ var on=ll[i].getAttribute('data-view')===pref; ll[i].classList.toggle('is-on', on); if(on){ ll[i].setAttribute('aria-current','true'); } else { ll[i].removeAttribute('aria-current'); } }
    }catch(e){}
  }

  function syncBreadcrumbs(doc){
    try{
      var live=document.querySelector('.cvn-bc-section'), nw=doc.querySelector('.cvn-bc-section');
      if(live && nw){ live.innerHTML=nw.innerHTML; runScripts(live); }
      else if(live){ live.innerHTML=''; }
    }catch(e){}
  }

  function fireAnalytics(){ try{ if(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish==='function'){ Shopify.analytics.publish('page_viewed', {}); } }catch(e){} }

  /* ⚠ STYLES BEFORE MARKUP — the soft-nav flash fix. A <link rel=stylesheet> INSIDE swapped-in
     content applies ASYNCHRONOUSLY, so any section carrying its own sheet (Our Pieces, the gift
     page) painted unstyled for a frame or two after the swap: the raw image at full width, then
     the real layout snapping in. Before the innerHTML swap, every stylesheet the incoming
     #MainContent carries that this document does not already have is lifted into <head> and
     awaited (bounded, CSS_WAIT_MS), so the FIRST paint of the new content is the styled one.
     The in-content copy of the link stays in the swapped markup; same href, so it is a cache hit
     and applies nothing new. Inline <style> blocks apply synchronously on insertion and need no
     help. A sheet that fails or stalls past the cap swaps anyway — worst case is the old flash,
     never a hung navigation. loadedCss persists per page load, so a repeat visit to the same
     section swaps with zero added wait. */
  var loadedCss={};
  (function(){ var ls=document.querySelectorAll('link[rel="stylesheet"][href]'); for(var i=0;i<ls.length;i++){ loadedCss[ls[i].href]=1; } })();
  var CSS_WAIT_MS=450;
  function preloadStyles(nm){
    var links=nm.querySelectorAll('link[rel="stylesheet"][href]');
    var pending=0, done=null;
    function settle(){ pending--; if(pending===0 && done){ done(); } }
    for(var i=0;i<links.length;i++){
      var raw=links[i].getAttribute('href'); if(!raw) continue;
      var href; try{ href=new URL(raw, location.href).href; }catch(e){ continue; }
      if(loadedCss[href]) continue;
      loadedCss[href]=1; pending++;
      var l=document.createElement('link'); l.rel='stylesheet'; l.href=href;
      l.onload=settle; l.onerror=settle;
      document.head.appendChild(l);
    }
    if(pending===0) return null;
    return new Promise(function(res){ done=res; setTimeout(res, CSS_WAIT_MS); });
  }

  function swap(html, url, push){
    var doc;
    try{ doc=new DOMParser().parseFromString(html,'text/html'); }catch(e){ window.location.assign(url); return; }
    var nm=doc.getElementById('MainContent');
    if(!nm){ window.location.assign(url); return; }
    if(push!==false){ try{ history.pushState({cvn:1}, '', url); }catch(e){} }
    if(doc.title){ document.title=doc.title; }
    /* pushState stays ABOVE the stylesheet wait: the full-bleed collage's MutationObserver reads
       location.pathname at insertion time and depends on the URL already being the incoming
       page's when the swap happens (see store_management.md → the collage decision). */
    var wait=preloadStyles(nm);
    function finish(){
      /* ⚠ ORPHAN CLEANUP RUNS BEFORE THE SWAP, NEVER AFTER — and the ordering is the whole fix.
         Dawn's ModalDialog.connectedCallback RELOCATES the zoom modal to <body> the instant it is
         inserted, so "not inside #MainContent" — the orphan test — is TRUE of the INCOMING page's
         own modal microseconds after the line below runs. Called afterwards, this deleted the modal
         the page had just built: modal-opener's data-modal then resolved to nothing, modal.show was
         never reached, and the magnifier did nothing at all on every product opened without a hard
         load (the classic "works only after a refresh" shape, with a fresh cause). Here it sees the
         OUTGOING page's relocated modals, which is the only thing it was ever meant to remove.
         (During the stylesheet wait the outgoing slot holds only the loader, so the test is
         unchanged by the wait.) */
      cleanupOrphans();
      if(keepEl && keepEl.parentNode===main){
        /* graceful exit v2: the mark floats above (position:fixed) while the new page
           renders beneath it — remove everything but the mark, then insert the content */
        var kids=[].slice.call(main.children);
        for(var ci=0;ci<kids.length;ci++){ if(kids[ci]!==keepEl) main.removeChild(kids[ci]); }
        main.insertAdjacentHTML('beforeend', nm.innerHTML);
        keepEl=null;
      } else {
        main.innerHTML=nm.innerHTML;
      }
      runScripts(main);
      syncToggle(doc);
      syncBreadcrumbs(doc);
      try{ window.scrollTo(0,0); }catch(e){}
      barDone();
      navigating=false;
      fireAnalytics();
      try{ document.dispatchEvent(new CustomEvent('cvn:navigated', {detail:{url:url}})); }catch(e){}
    }
    /* GRACEFUL EXIT v4 (Zeus's order): hold the loader while the loop runs AT 1x to
       the next rest pose (wordmark or logo), pause on it, fade the MARK out on the
       blank void (200ms), THEN swap the content in. Track fallback keeps the plain swap. */
    function settle(){
      var pl=document.getElementById('cvn-pageload');
      if(!(pl && pl.classList.contains('cvnb-navload') && window.cvnBootPlan)){ finish(); return; }
      var plan=null; try{ plan=window.cvnBootPlan(pl); }catch(e){}
      function out(){
        /* v4 order (Zeus): the mark disappears FIRST, on the still-blank void, THEN the
           content swaps in. Fade the svg child — the markbox's own appear/zoom animation
           fills would beat an inline opacity on the box itself. The swap chains on the
           fade's OWN transitionend: wall-clock timers coalesce with the fade's first
           frame under load, collapsing the sequence. */
        var done=false;
        function swap(){ if(done) return; done=true; finish(); }
        try{
          var el=pl.querySelector(pl.classList.contains('cvnb-snow') ? '.cvnb-snowsvg' : '.cvnb-svg');
          if(el){
            el.style.animation='none';
            el.style.transition='opacity 200ms ease';
            el.getBoundingClientRect();
            el.style.opacity='0';
            el.addEventListener('transitionend', function(ev){ if(!ev || ev.propertyName==='opacity') swap(); }, {once:true});
            /* a stall can defer the transition's start past any fixed timer: long
               fallback first, re-armed short once the fade actually starts */
            var fb=setTimeout(swap, 700);
            el.addEventListener('transitionstart', function(ev){
              if(ev && ev.propertyName!=='opacity') return;
              clearTimeout(fb); fb=setTimeout(swap, 420);
            }, {once:true});
            return;
          }
        }catch(e){}
        setTimeout(swap, 480); // no mark to fade — just swap
      }
      if(plan){ plan.untilPose(out); } else { out(); }
    }
    if(wait){ wait.then(settle); } else { settle(); }
  }

  function go(url, push){
    if(navigating) return; navigating=true; keepEl=null;
    cleanupOrphans();
    clearBreadcrumbs();
    barStart();
    var markOk=false; try{ markOk=wantsMark(new URL(url, location.href)); }catch(e){}
    try{
      main.innerHTML=loaderHTML(markOk); // carries the camera ratio and the opening — see camZw()
      if(markOk && window.cvnBootMark){
        var plx=main.querySelector('#cvn-pageload');
        var built=(plx && plx.classList.contains('cvnb-snow'))
          ? window.cvnBootSnow(plx.querySelector('.cvnb-snowsvg'), plx.getAttribute('data-cvnb-open')==='snow-logo', 'nav')
          : window.cvnBootMark(main.querySelector('#cvn-pageload .cvnb-svg'));
        if(!built){ main.innerHTML=TRACK; }
      }
      window.scrollTo(0,0);
    }catch(e){}
    fetch(url, {credentials:'same-origin', headers:{'X-CVN-Nav':'1'}}).then(function(r){
      var ct=(r.headers.get('content-type')||'');
      if(!r.ok || ct.indexOf('text/html')===-1){ throw new Error('bad'); }
      return r.text();
    }).then(function(html){ swap(html, url, push); }).catch(function(){ navigating=false; window.location.assign(url); });
  }

  window.cvnNavigate = function(url){ try{ var u=new URL(url, location.href); if(u.origin!==location.origin){ window.location.href=url; return; } go(u.href, true); }catch(e){ window.location.href=url; } };

  function closeMenus(){
    try{
      var h=document.querySelector('.header-wrapper')||document.querySelector('.header')||document.querySelector('header')||document;
      /* MOBILE drawer: close via Dawn's own summary toggle so its state stays consistent (no leftover grey backdrop; next open still fills). */
      var drawer=h.querySelector('header-drawer details[open], .menu-drawer-container[open]');
      if(drawer){ var ds=drawer.querySelector('summary'); if(ds){ ds.click(); } }
      /* DESKTOP mega-menu dropdowns: a plain close is fine (no drawer animation state). */
      var open=h.querySelectorAll('details[open]');
      for(var i=0;i<open.length;i++){ var d=open[i]; if(d.closest('header-drawer') || d.classList.contains('menu-drawer-container')) continue; d.removeAttribute('open'); }
      document.body.classList.remove('overflow-hidden','overflow-hidden-mobile','overflow-hidden-tablet');
      if(document.activeElement && document.activeElement.blur){ document.activeElement.blur(); }
    }catch(e){}
  }

  function internalLink(a){
    if(!a || !a.href) return null;
    if(a.target && a.target!=='_self') return null;
    if(a.hasAttribute('download')) return null;
    /* the collection grid's Show more (snippets/cvn-show-more) loads its batch in place: never a soft nav, never a hover prefetch of the whole next page */
    if(a.hasAttribute('data-cvn-more-btn')) return null;
    var raw=a.getAttribute('href')||'';
    if(!raw || raw.charAt(0)==='#' || raw.indexOf('mailto:')===0 || raw.indexOf('tel:')===0 || raw.indexOf('javascript:')===0) return null;
    var u; try{ u=new URL(a.href, location.href); }catch(e){ return null; }
    if(u.origin!==location.origin) return null;
    return u;
  }
  function skip(u){ return /\/(cart|checkout|account)(\/|$)/.test(u.pathname); }

  function applyLayoutPref(u){
    try{
      var pref=layoutPref(); if(!pref) return u;
      if(/^\/collections\/[^\/]+$/.test(u.pathname)){
        if(pref==='grid'){ u.searchParams.set('view','grid'); }
        else { u.searchParams.delete('view'); }
      }
    }catch(e){}
    return u;
  }

  /* SEARCH IS A SOFT NAV TOO (Zeus). Searching used to be the one way around the store that
     always hard-loaded: the click rule below never sees a form submit, and it skipped every link
     inside a <form> — which is exactly where the search suggestions live (predictive-search sits
     inside the header's and the search page's search form). A hard load puts up the full-screen
     boot screen whenever the page misses its 350ms grace (snippets/cvn-boot.liquid), and the
     search grid always does, so every search and every suggestion clicked replayed the logo.
     Now: a GET form aimed at /search is fetched like any link (quiet track — /search is not in the
     menu's mark list, see wantsMark), and a suggestion link is followed like any link. Dawn's
     predictive-search cancels the submit itself when a suggestion is highlighted (it clicks that
     suggestion instead), so the submit hook runs in the BUBBLE phase and honours defaultPrevented.
     Every other form (cart, product, newsletter, the filter drawer's fetch) is left alone. */
  var SEARCH_PATH=/^(\/[a-z]{2}(-[a-z]{2})?)?\/search$/i;
  function closeSearch(el){
    try{
      var ps=el.closest('predictive-search'); if(ps && typeof ps.close==='function') ps.close();
      var dm=el.closest('details-modal'); var d=dm && dm.querySelector('details');
      if(dm && d && d.hasAttribute('open') && typeof dm.close==='function') dm.close(false);
    }catch(e){}
  }

  document.addEventListener('click', function(e){
    if(e.defaultPrevented || e.button!==0 || e.metaKey||e.ctrlKey||e.shiftKey||e.altKey) return;
    var a=e.target.closest && e.target.closest('a'); var u=internalLink(a); if(!u) return;
    if(skip(u)) return;
    var inSuggest=!!a.closest('predictive-search');
    if(!inSuggest && a.closest('facet-filters-form, .facets, .facets-wrapper, .cvn-vt, form')) return;
    var tu=applyLayoutPref(new URL(u.href, location.href));
    if(tu.pathname===location.pathname && tu.search===location.search) return;
    /* same path, new query: a soft nav only where the query IS the page — a collection, or a
       search (a query suggestion clicked ON the search page is /search -> /search) */
    if(tu.pathname===location.pathname && !/^\/collections\/[^\/]+$/.test(tu.pathname) && !SEARCH_PATH.test(tu.pathname.replace(/\/+$/,''))) return;
    e.preventDefault();
    if(inSuggest) closeSearch(a);
    closeMenus();
    go(tu.href, true);
  }, true);

  document.addEventListener('submit', function(e){
    if(e.defaultPrevented) return;
    var f=e.target; if(!f || f.tagName!=='FORM') return;
    if((f.getAttribute('method')||'get').toLowerCase()!=='get') return;
    if(f.target && f.target!=='_self') return;
    var u; try{ u=new URL(f.getAttribute('action')||location.href, location.href); }catch(x){ return; }
    if(u.origin!==location.origin || !SEARCH_PATH.test(u.pathname.replace(/\/+$/,''))) return;
    try{ u.search=new URLSearchParams(new FormData(f)).toString(); }catch(x){ return; }
    e.preventDefault();
    closeSearch(f);
    closeMenus();
    go(u.href, true);
  });

  window.addEventListener('popstate', function(){ go(location.href, false); });

  var cache={}, head=document.head, conn=navigator.connection||{};
  var allowPrefetch = (window.cvnNavPrefetch !== false) && !conn.saveData && !/(^|-)2g$/.test(conn.effectiveType||'');
  var supports=(function(){ try{ var l=document.createElement('link'); return l.relList && l.relList.supports && l.relList.supports('prefetch'); }catch(e){ return false; } })();
  function prefetch(u){ if(!allowPrefetch||!supports) return; if(u.pathname===location.pathname) return; var href=u.href; if(cache[href]) return; cache[href]=1; var l=document.createElement('link'); l.rel='prefetch'; l.href=href; head.appendChild(l); }
  function tryPrefetch(a){ var u=internalLink(a); if(u && !skip(u)) prefetch(applyLayoutPref(new URL(u.href, location.href))); }
  var hoverT=null;
  document.addEventListener('mouseover', function(e){ var a=e.target.closest && e.target.closest('a'); if(!a) return; if(hoverT) clearTimeout(hoverT); hoverT=setTimeout(function(){ tryPrefetch(a); }, 55); }, {passive:true});
  document.addEventListener('mouseout', function(){ if(hoverT){ clearTimeout(hoverT); hoverT=null; } }, {passive:true});
  document.addEventListener('mousedown', function(e){ if(e.button!==0) return; var a=e.target.closest && e.target.closest('a'); if(a) tryPrefetch(a); }, {passive:true});
  document.addEventListener('touchstart', function(e){ var a=e.target.closest && e.target.closest('a'); if(a) tryPrefetch(a); }, {passive:true});
})();

/* ── REVIEWS AFTER A SOFT NAV (Judge.me) + the rating link ─────────────────────────────────
   ⚠ The trap: Judge.me's app-embed loader.js runs ONCE per hard load and mounts only the widgets
   already in the DOM at that moment. A page reached by cvnNavigate arrives with the widget's raw
   server-rendered fallback (a bulleted star histogram, photo links with no src, a spinner that
   never stops) and nothing ever mounts it: the loader is guarded by jdgm._loaderExecuted, and each
   widget's entry module (review_widget.js …) builds one private manager with an `initialized`
   flag and never exposes it. Re-inserting the entry <script> is a no-op (a module URL evaluates
   once per document).
   The fix mirrors the loader's own step for every `.jdgm-widget[data-entry-point]` in the swapped
   content: pull that entry's stylesheets from Judge.me's manifest (the loader adds them only for
   widgets present at hard load), then load the entry as a <script type=module> under a fresh
   `?cvnnav=N` query — a new module URL, so its few-hundred-byte body runs again and mounts every widget of its kind on the
   page, while the heavy chunks it imports are shared and stay cached. Covers ANY revamped
   Judge.me widget on ANY page (review widget, carousels, snippets, trust badge, grids), not just
   the product page. The older jQuery widgets (star badges on product cards) are re-scanned with
   jdgm.customizeBadges() when Judge.me's core is already loaded.
   The `?cvnnav` suffix and the manifest shape are Judge.me internals: if they rename them this
   fails SOFT (a warning, the raw fallback, exactly the old state) and a hard load still works. */
(function(){
  if (window.cvnJdgmSoftnavBound) return;
  window.cvnJdgmSoftnavBound = true;
  var runN = 0, manifest = null;

  function getManifest(base){
    if (!manifest) {
      manifest = fetch(base + 'manifest.json?v=' + Date.now())
        .then(function(r){ return r.json(); })
        .catch(function(){ manifest = null; return {}; });
    }
    return manifest;
  }
  function addCss(base, m, key, seen){
    if (!key || seen[key]) return; seen[key] = 1;
    var e = m[key]; if (!e) return;
    (e.css || []).forEach(function(f){
      var h = base + f;
      if (!document.querySelector('link[href="' + h + '"]')) {
        var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = h; document.head.appendChild(l);
      }
    });
    (e.imports || []).forEach(function(k){ addCss(base, m, k, seen); });
  }
  function remount(){
    var j = window.jdgm; if (!j) return;
    var main = document.getElementById('MainContent'); if (!main) return;
    try { if (typeof j.customizeBadges === 'function' && main.querySelector('.jdgm-preview-badge, .judgeme-preview-badge')) j.customizeBadges(); } catch (e) {}
    var base = j.CDN_BASE_URL; if (!base) return;
    var ws = main.querySelectorAll('.jdgm-widget[data-entry-point][data-entry-key]');
    if (!ws.length) return;
    var entries = {};
    for (var i = 0; i < ws.length; i++) {
      var w = ws[i];
      entries[w.dataset.entryPoint] = w.dataset.entryKey;
      /* what loader.js does before mounting: hide the legacy shell, drop the SSR fallback */
      var lg = w.querySelector('.jdgm-rev-widg'); if (lg) lg.style.display = 'none';
      var ssr = w.querySelector('.jdgm-ssr-reviews'); if (ssr && ssr.parentNode) ssr.parentNode.removeChild(ssr);
    }
    var n = ++runN;
    getManifest(base).then(function(m){
      Object.keys(entries).forEach(function(ep){
        addCss(base, m, entries[ep], {});
        /* ⚠ NEVER a literal import() here: Shopify's asset minifier rewrites import() into
           __toESM(require(…)), which does not exist in a browser, so the remount failed silently
           on the CDN copy while the source read correctly. A <script type=module> with the fresh
           URL is what loader.js itself does, and nothing rewrites it. */
        var sc = document.createElement('script');
        sc.type = 'module'; sc.src = base + ep + '?cvnnav=' + n;
        sc.onerror = function(){ try { console.warn('[cvn] Judge.me remount failed', ep); } catch (e) {} };
        document.head.appendChild(sc);
      });
    });
  }
  document.addEventListener('cvn:navigated', remount);

  /* PHONE PLACEMENT — on ≤749px the reviews row (sections/cvn-reviews) moves up to sit directly
     under "Shipping & Returns" (the last row of the product info stack, snippets/cvn-ship-row) and
     is tagged .cvn-rv--inline so it takes that accordion stack's look; wider, it goes back to its own
     section (full width, between "Also available as" and "More like this").
     ⚠ It goes right AFTER the .product block (after its .cvn-below-media holder), NOT inside the info
     column. Visually identical — Shipping & Returns is the column's last row — but on a phone the
     media column is STICKY for the height of .product: inside the column an open review list
     stretched that range, so reviews scrolled in the bottom half of the screen under a pinned photo,
     and the rating link's jump parked the row BEHIND the photo. Outside it, the pin releases at
     Shipping & Returns and reviews read full-screen.
     A comment node marks the home spot so the way back is exact. Runs from here (bound once per
     page) on load, after every soft nav, and on crossing the breakpoint; moving a mounted Judge.me
     widget is safe — same DOM node, its listeners travel with it. No .product (not a product
     template) = the row stays in its section. */
  var MQ = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  function placeReviews(){
    var box = document.getElementById('cvn-reviews'); if (!box) return;
    if (!box.cvnHome) {
      if (!box.parentNode) return;
      box.cvnHome = document.createComment('cvn-reviews-home');
      box.parentNode.insertBefore(box.cvnHome, box);
    }
    var prod = document.querySelector('#MainContent .product');
    var anchor = prod;
    if (prod && prod.nextElementSibling && prod.nextElementSibling.classList.contains('cvn-below-media')) anchor = prod.nextElementSibling;
    if (MQ && MQ.matches && anchor && anchor.parentNode) {
      if (anchor.nextSibling !== box) anchor.parentNode.insertBefore(box, anchor.nextSibling);
      box.classList.add('cvn-rv--inline');
    } else {
      var h = box.cvnHome;
      if (h.parentNode && h.nextSibling !== box) h.parentNode.insertBefore(box, h.nextSibling);
      box.classList.remove('cvn-rv--inline');
    }
  }
  placeReviews();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeReviews);
  document.addEventListener('cvn:navigated', placeReviews);
  if (MQ) { if (MQ.addEventListener) MQ.addEventListener('change', placeReviews); else if (MQ.addListener) MQ.addListener(placeReviews); }

  /* The rating link under the title (snippets/cvn-rating-badge) points at #cvn-reviews: open the
     collapsed reviews row, then scroll to it. Delegated from document so it is bound once and
     works on hard and soft loads alike. */
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('a[href="#cvn-reviews"]');
    if (!a) return;
    var box = document.getElementById('cvn-reviews'); if (!box) return;
    e.preventDefault();
    var d = box.querySelector('details'); if (d) d.open = true;
    /* ⚠ A one-shot scrollIntoView OVERSHOOTS here: the page ABOVE the row gets ~100px shorter while
       the scroll runs (the header shrinks, the top area compacts — measured 4637 → 4534px on a
       phone), so a target computed at the start lands the row above the screen. Scroll, then re-aim
       once the scroll has settled, up to three times, against the header's LIVE bottom edge. */
    var hdr = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
    function off(){ return Math.max(0, hdr ? hdr.getBoundingClientRect().bottom : 0) + 10; }
    window.scrollTo({ top: box.getBoundingClientRect().top + window.pageYOffset - off(), behavior: 'smooth' });
    var tries = 0;
    (function settle(){
      setTimeout(function(){
        var dy = box.getBoundingClientRect().top - off();
        if (Math.abs(dy) > 6 && tries++ < 3) { window.scrollBy({ top: dy, behavior: 'smooth' }); settle(); }
      }, 700);
    })();
  });
})();
